export default __webpack_public_path__ + "static/media/Graphics_business-card-back-min.a71b9334.jpg";